export const analyticsEvents = {
  apiAccountCreated: "api_account_created",
  apiAccountProfileUpdated: "api_account_profile_updated",
  apiAccountSignedIn: "api_account_signed_in",
  apiCliLoginTokenIssued: "api_cli_login_token_issued",
  apiCliLoginCodeVisited: "api_cli_login_code_visited",
  accountPageLinkDiscordAccountClicked:
    "account_page_link_discord_account_clicked",
  accountPageSignInWithGithubClicked:
    "account_page_sign_in_with_github_clicked",
  accountPageSignOutClicked: "account_page_sign_out_clicked",
  cliLoginPageAuthCommandCopied: "cli_login_page_auth_command_copied",
  cliLoginPageTokenCopied: "cli_login_page_token_copied",
  // PostHog's own exposure event. The backend decides the value; this records that
  // someone was shown it, which is what an experiment counts.
  featureFlagCalled: "$feature_flag_called",
  footerContactEmailClicked: "footer_contact_email_clicked",
  footerDiscordClicked: "footer_discord_clicked",
  footerGithubClicked: "footer_github_clicked",
  footerPrivacyClicked: "footer_privacy_clicked",
  footerTermsClicked: "footer_terms_clicked",
  footerTwitterClicked: "footer_twitter_clicked",
  homepageBoydAreaClicked: "homepage_boyd_area_clicked",
  homepageBoydAreaDwelled: "homepage_boyd_area_dwelled",
  homepageAgentPromptCopied: "homepage_agent_prompt_copied",
  homepageDashboardLinkClicked: "homepage_dashboard_link_clicked",
  homepageCoworldReadmeClicked: "homepage_coworld_readme_clicked",
  homepageCoworldRepoClicked: "homepage_coworld_repo_clicked",
  jobsPageApplyClicked: "jobs_page_apply_clicked",
  observatoryBackToDashboardClicked: "observatory_back_to_dashboard_clicked",
  observatoryLeaguePlayPromptCopied: "observatory_league_play_prompt_copied",
  observatoryNavbarElevatePrivilegesClicked:
    "observatory_navbar_elevate_privileges_clicked",
  observatoryNavbarDropPrivilegesClicked:
    "observatory_navbar_drop_privileges_clicked",
  observatoryNavbarSignOutClicked: "observatory_navbar_sign_out_clicked",
  previewCtaClicked: "preview_cta_clicked",
  siteNavAccountMenuSignOutClicked: "site_nav_account_menu_sign_out_clicked",
  sugarscapePageJoinLeagueClicked: "sugarscape_page_join_league_clicked",
  sugarscapePageGetStartedClicked: "sugarscape_page_get_started_clicked",
  sugarscapePageWatchLiveClicked: "sugarscape_page_watch_live_clicked",
  sugarscapePageResourceLinkClicked: "sugarscape_page_resource_link_clicked",
  watchJoinLeagueClicked: "watch_join_league_clicked",
} as const;

export type AnalyticsEventName =
  (typeof analyticsEvents)[keyof typeof analyticsEvents];
